import { Delete } from "@mui/icons-material";
import { sharedFilesData } from "../../Actions/getSharedFiles";
import { UIactions } from "../../../../store/slices/UI";
import useUIBp from "../../../../Hooks/useUIBoilerplate";
import ActionButton from "../../../UI/BasicLayout/Components/FilterPlusActions/ActionButton";

const UIText = {
  "es-CL": { label: "Eliminar", fixedTooltip: "Eliminar enlace" },
  "en-US": { label: "Delete", fixedTooltip: "Delete link" },
};
const DeleteLink = () => {
  const { dispatch, UI, warehouse } = useUIBp();
  const sharedFiles = warehouse[sharedFilesData] ?? [];
  let selected = UI.selected ?? [];

  const onClick = () => {
    let links = [];
    for (const id of selected) {
      const link = sharedFiles.find((x) => x.id === id);
      links.push(link);
    }

    dispatch(
      UIactions.openModal({
        type: "delete-shared-links",
        payload: { links },
      })
    );
  };

  return (
    <ActionButton
      {...{ disabled: !selected.length, onClick, UIText, icon: <Delete /> }}
    />
  );
};

export default DeleteLink;
